import {inject, Injectable} from '@angular/core';
import {TelegramAttachAllAdvertsApiService} from "./telegram-attach-all-adverts-api.service";
import {AttachAllFormField, TelegramAttachAllParams} from "../types/telegram-attach-all-adverts-modal.types";
import {FormControl, FormGroup} from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class TelegramAttachAllAdvertsService {
  private telegramAttachAllApiService: TelegramAttachAllAdvertsApiService = inject(TelegramAttachAllAdvertsApiService);

  public telegramAttachAll(telegramAttachAllParams: TelegramAttachAllParams) {
    return new Promise((resolve, reject) => {
      this.telegramAttachAllApiService.telegramAttachAll(telegramAttachAllParams).subscribe({
        next: resolve,
        error: (error) => reject(error)
      });
    });
  }

  public initForm(formFields: Array<AttachAllFormField>): FormGroup {
    const group: { [key: string]: FormControl } = {};

    formFields.forEach(field => {
      group[field.fieldName] = new FormControl(null, field.validators || []);
    });

    return new FormGroup(group);
  }
}
